export default __webpack_public_path__ + "static/Chenonceau_Loire_Valley_France-0f017f44c3c1f62f86ad8c7d87713225.jpg";